// 测试
import * as test from './utils/test'
// 常用正则表达式合集
import regExp from './utils/regExp'
// cookie操作
import cookie from './utils/cookie'
// storage操作
import storage from './utils/storage'
// 数组操作
import array from './utils/array'

export {
  test,
  regExp,
  cookie,
  storage,
  array
}
